import currency from 'currency.js';

// Used to specify precision in rounded numbers
const getMultiplier = (decimal_places: number): number =>
  Math.pow(10, decimal_places);

export const getConversionFromUSD = ({
  exchange_rate = 1,
  decimal_places = 2,
  value,
}: {
  decimal_places?: number;
  exchange_rate?: number;
  value: number;
}) => {
  const multiplier = getMultiplier(decimal_places);
  return (
    Math.round(
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'currency' is not assignable to p... Remove this comment to see the full error message
      currency(value * multiplier).multiply(exchange_rate)
    ) / multiplier
  );
};

export const getConversionToUSD = ({
  exchange_rate = 1,
  decimal_places = 2,
  value,
}: {
  decimal_places?: number;
  exchange_rate?: number;
  value: number;
}) => {
  const multiplier = getMultiplier(decimal_places);
  return (
    Math.round(
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'currency' is not assignable to p... Remove this comment to see the full error message
      currency(value * multiplier).divide(exchange_rate)
    ) / multiplier
  );
};

export const removeDoubleZeros = ({
  currency_text,
}: {
  currency_text: string;
}) => currency_text.replace(/(\.0*?)0+$/, '');
